import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import {
  RoleManagementState,
  RoleData,
  AccessModules,
} from "../interfaces/IRoleManagement";
import { addRole } from "../apis/roleManagementService";

const initialState: RoleManagementState = {
  role: "",
  accessModules: {
    claimStatus: false,
    patientList: false,
    caseList: false,
    opdBillList: false,
    ipdBillList: false,
    echsCodes: false,
    healthCareList: false,
    schemeOnboarding: false,
    viewSchemes: false,
    reports: false,
    dischargeSummary: false,
    roleManagement: false,
    visits: false,
    patientAdd: false,
    patientView: false,
    patientEdit: false,
    schemeAdd: false,
    schemeView: false,
    schemeEdit: false,
    caseAdd: false,
    caseView: false,
    caseEdit: false,
    visitAdd: false,
    visitView: false,
    visitEdit: false,
    referralAdd: false,
    referralView: false,
    referralEdit: false,
    casePreAuthIntimate: false,
    casePreAuthView: false,
    casePreAuthSubmission: false,
    cghsSchemeRegistrationAdd: false,
    cghsSchemeRegistrationView: false,
    cghsCasePreAuthInitiateAdd: false,
    echsCasePreAuthInitiateAdd: false,
    ihxCasePreAuthInitiateAdd: false,
    ihxCasePreAuthSaveOnPortalAdd: false,
    ihxQueryAdd: false,
    ihxQueryEdit: false,
    ihxQueryView: false,
    starHealthCasePreAuthInitiateAdd: false,
    vidalCasePreAuthInitiateAdd: false,
    enhancementIntimation: false,
    enhancementReview: false,
    enhancementSubmission: false,
    dischargeIntimation: false,
    dischargeReview: false,
    dischargeSubmission: false,
    claimSubmission: false,
    claimCreation: false,
  },
  loading: false,
  error: null,
};

export const submitRole = createAsyncThunk<
  RoleData,
  void,
  { state: { roleManagement: RoleManagementState } }
>("roleManagement/submitRole", async (_, { getState }) => {
  const { roleManagement } = getState();
  const response = await addRole({
    id: 0,
    role: roleManagement.role,
    accessModulesRequest: {
      ...roleManagement.accessModules,
      id: 0,
    },
  });
  return response;
});

const roleManagementSlice = createSlice({
  name: "roleManagement",
  initialState,
  reducers: {
    setRole: (state, action: PayloadAction<string>) => {
      state.role = action.payload;
    },
    toggleAccessModule: (state, action: PayloadAction<keyof AccessModules>) => {
      state.accessModules[action.payload] =
        !state.accessModules[action.payload];
    },
    resetRoleManagement: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitRole.fulfilled, (state) => {
        state.loading = false;
        // Reset state or handle success
      })
      .addCase(submitRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "An error occurred";
      });
  },
});

export const { setRole, toggleAccessModule, resetRoleManagement } =
  roleManagementSlice.actions;
export default roleManagementSlice.reducer;
